export const reviewSummary = {
  google: { rating: 4.4, count: 28 },
  homeAdvisor: { rating: 4.8, count: 65 },
  angi: { rating: 4.8, count: 65 },
};

export const testimonials = [
  {
    id: 1,
    quote: "The floors are smooth and even all the way to the edges. They look like new — outstanding results! Tim and his crew were professional from start to finish. Our house actually sold within five days and buyers kept commenting on the beautiful floors.",
    author: "Teresa R.",
    location: "Linthicum Heights, MD",
    service: "Hardwood Refinishing",
    rating: 5,
    source: "Google",
  },
  {
    id: 2,
    quote: "Damon and the team refinished my floors to brand new! When pulling up carpet they found and repaired water damage underneath without any extra hassle. Dana in the office kept me updated throughout — exceptional communication and exceptional results.",
    author: "Damon B.",
    location: "Baltimore, MD",
    service: "Hardwood Refinishing",
    rating: 5,
    source: "HomeAdvisor",
  },
  {
    id: 3,
    quote: "Tim Walsh came out himself for the estimate. 30+ years of experience really shows — he explained everything thoroughly, zero pressure, and the price was the most reasonable of three quotes. Install crew was clean, on time, and the quality is incredible.",
    author: "Michael S.",
    location: "Annapolis, MD",
    service: "Hardwood Installation",
    rating: 5,
    source: "Angi",
  },
  {
    id: 4,
    quote: "Two rooms refinished in a single day. I couldn't believe how fast and clean the crew was. They matched the existing stain on my original oak floors perfectly — you can't tell where old ends and refinished begins. Absolutely recommend Premier.",
    author: "Karen L.",
    location: "Columbia, MD",
    service: "Hardwood Refinishing",
    rating: 5,
    source: "Google",
  },
  {
    id: 5,
    quote: "I've used several flooring companies over the years and Premier stands apart. They use their own crews, not subcontractors — and it shows in the consistency of the work. Every plank is perfect. Dana was so helpful with scheduling around my busy week.",
    author: "Robert & Lisa T.",
    location: "Rockville, MD",
    service: "Hardwood Installation",
    rating: 5,
    source: "HomeAdvisor",
  },
  {
    id: 6,
    quote: "Called with a floor repair job two other companies turned down. Premier not only fixed it, they matched the 20-year-old stain seamlessly. Professional, honest, and delivered exactly what they promised. This is the company you want.",
    author: "Patricia H.",
    location: "Silver Spring, MD",
    service: "Floor Repair",
    rating: 4,
    source: "Google",
  },
];